import { Icon, TIconVariant } from '@/shared/ui/icon'
import { useStyles } from './styles'
import { ReferralItemType, UserByGamedId } from '../../types'
import { goToExternalUnifiedProfile } from '@/app/routing/events'
import { useFriendAction } from '@/pages/externalUnifiedProfile/hooks/useFriendAction'
import { useState } from 'react'
import { getFriendsListFx } from '../../effects'
import { useUnit } from 'effector-react'
import { $userToken } from '../../store'

interface ReferralItemProps extends ReferralItemType {
  index: number
}

export const ReferrallItem = (props: ReferralItemProps) => {
  const { classes } = useStyles()
  const { photo_url, username, ref_level, gigi_index, index, gamed_id, tid, level_premium } = props
  const icon: TIconVariant = level_premium === 1 ? 'referralPlus' : 'referralPlatinum'
  return (
    <div
      className={classes.root}
      onClick={() => goToExternalUnifiedProfile({ tid: tid, gamed_id: gamed_id, fromSocialTab: 2 })}
    >
      <div className={classes.placeAndImgWrapper}>
        <span className={classes.placeText}>{index}</span>
        <div className={classes.imgWrapper}>
          <img src={photo_url} alt="" className={classes.img} />
          <div className={classes.levelAndNameWrapper}>
            <div className={classes.nameAndSubscriptionWrapper}>
              <span className={classes.nameText}>{username}</span>
              {level_premium && <Icon view={icon} width={16} />}
            </div>
            <span className={classes.levelText}>{ref_level} level</span>
          </div>
        </div>
      </div>
      <div className={classes.valueWrapper}>
        <span className={classes.valueText}>{gigi_index}</span>
        <Icon view="gigi" width={18} />
      </div>
    </div>
  )
}

type FriendsItemType = {
  photo_url: string
  username: string
  level_premium: number
  gamed_id: string
  tid: number
}

export const FriendsItem = (props: FriendsItemType) => {
  const { classes } = useStyles()
  const { photo_url, username, gamed_id, tid, level_premium } = props

  const icon: TIconVariant = level_premium === 1 ? 'referralPlus' : 'referralPlatinum'
  return (
    <div
      className={classes.root}
      onClick={() => goToExternalUnifiedProfile({ tid: tid, gamed_id: gamed_id, fromSocialTab: 0 })}
    >
      <div className={classes.placeAndImgWrapper}>
        <div className={classes.imgWrapper}>
          <img src={photo_url} alt="" className={classes.img} />
          <div className={classes.levelAndNameWrapper}>
            <div className={classes.nameAndSubscriptionWrapper}>
              <span className={classes.nameText}>{username}</span>
              {level_premium !== 0 && <Icon view={icon} width={20} />}
            </div>
          </div>
        </div>
      </div>
      <div className={classes.valueWrapper}>
        <Icon view="arrowRight" width={22} />
      </div>
    </div>
  )
}

export const SearchedUserItem = (props: UserByGamedId) => {
  const { classes } = useStyles()
  const { avatar, username, gamed_id, is_friend, friend_tid, premium_level } = props
  const [isFriend, setIsFriend] = useState(is_friend)
  const userToken = useUnit($userToken)
  const icon: TIconVariant = premium_level === 1 ? 'referralPlus' : 'referralPlatinum'
  const friendIcon: TIconVariant = isFriend ? 'friendAdded' : 'friendNotAdded'

  const { handleFriendAction } = useFriendAction(isFriend, friend_tid)

  const handleFriend = async (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation()
    setIsFriend(!isFriend)
    await handleFriendAction()
    await getFriendsListFx({ token: userToken!, page: 1, size: 1000 })
  }

  return (
    <div
      className={classes.root}
      onClick={() => goToExternalUnifiedProfile({ tid: friend_tid, gamed_id: gamed_id, fromSocialTab: 0 })}
    >
      <div className={classes.placeAndImgWrapper}>
        <div className={classes.imgWrapper}>
          <img src={avatar} alt="" className={classes.img} />
          <div className={classes.levelAndNameWrapper}>
            <div className={classes.nameAndSubscriptionWrapper}>
              <span className={classes.nameTextChips}>{username}</span>
              {premium_level !== 0 && <Icon view={icon} width={20} />}
            </div>
          </div>
        </div>
      </div>
      <div className={classes.valueWrapper}>
        <div onClick={handleFriend}>
          <Icon view={friendIcon} width={22} />
        </div>
        <Icon view="arrowRight" width={22} />
      </div>
    </div>
  )
}
